import * as _ from 'lodash';

import {
  Component,
  ViewEncapsulation,
  Input, Inject, OnInit
} from '@angular/core';

import {
  Router,
  ActivatedRoute,
  NavigationEnd
} from '@angular/router';

import {
  UserContext
} from '../../../../services/user-context';

import {
  ApiService,
  AuthService,
  Util
} from '../../../../services';
import {LocationSummaryService} from '../../../../services/location-summary-service';
import {UserInfo} from '../../../../models';
import {DOCUMENT} from '@angular/common';
import {Subscription} from 'rxjs';

@Component({
  selector: 'app-navigation',
  encapsulation: ViewEncapsulation.None,
  templateUrl: './navigation.template.html',
  styleUrls: [
    './navigation.style.scss'
  ]
})
export class NavigationComponent implements OnInit {
  @Input()
  routeLinks: any[] = [
    {label: 'Dashboard', link: '/dashboard', icon: "home", space:true},
    {label: 'Clients', link: '/clients', icon: "people"}
  ];

  accountRequiredLinks: any[] = [];

  accountLinks: any[] = [
    {label: 'Account', path: '/accounts/:id/', icon: "settings", space:true},
    {label: 'Users', path: '/accounts/:id/users/', icon: "person"},
    {label: 'Locations', path: '/accounts/:id/locations/', icon: "location_on"},
    {label: 'Import', path: '/accounts/:id/import/', icon: "cloud_upload", space:true},
    {label: 'Export', path: '/accounts/:id/export/', icon: "cloud_download"},
    {label: 'Waivers', path: '/accounts/:id/waivers/', icon: "assignment_turned_in", space:true}
  ];

  public previousPath: string;
  brandLogo = "/assets/flh8.svg";

  accountSubscription: Subscription;

  constructor(@Inject(DOCUMENT) private document: Document,
              private router: Router,
              private util: Util,
              private api: ApiService,
              private userContext: UserContext,
              private authService: AuthService,
              private locationSummaryService: LocationSummaryService,
              private activatedRoute: ActivatedRoute ) {

    this.accountSubscription = this.userContext.accountObserver.subscribe( (account) => {
      this.addLink(this.accountLinks, {label: 'Publish', path: '/accounts/:id/publication/', icon: "web"}, ["publish"], ["administrator"] );
      this.addLink(this.accountRequiredLinks, {label: 'Telehealth', link: '/telehealth', icon: "videocam"}, ["telemedicine", "emr"] );
      this.addLink(this.accountRequiredLinks, {label: 'Teleconsult', link: '/telehealth', icon: "videocam"}, ["telecart"], null, "Telehealth" );
      this.addLink(this.accountLinks, {label: 'Curations', path: '/accounts/:id/curate/', icon: "view_module", space:true}, ["telecart"] );
      this.addLink(this.routeLinks, {label: 'Orders', link: '/orders', icon: "shopping_basket", space:true}, ["orthotics"], ["administrator"] );
    });

    this.brandLogo = `https://cdn.fitsamerica.com/brand/${document.location.hostname.toLowerCase().replace(/\./g,"_")}.svg`;
    if ( this.userContext.isAdministrator() || this.userContext.isManager()) {
      this.accountRequiredLinks.unshift({label: 'Appointments', link: '/appointments', icon: "event"});
    }

    this.addLink(this.routeLinks, {label: 'Accounts', link: '/accounts', icon: "business", space:true}, null, ["administrator"] );


    if ( this.userContext.isDistributor() ) {
      this.routeLinks = [
        {label: 'Dashboard', link: '/distributor/distributor-dashboard'},
        {label: 'Accounts', link: '/distributor/accounts'},
        {label: 'Locations', link: '/distributor/locations'},
        {label: 'Commissions', link: '/distributor/orders'}
      ];
    }


    this.userContext.userInfoObserver.subscribe((change: UserInfo) => {
      this.locationSummaryService.locationObserver.next(true);
    });

    this.router.events.subscribe((event: any) => {

      if (event instanceof NavigationEnd) {

        const lastActivatedRoute = this.util.getLastActivatedRoute(this.activatedRoute);
        this.previousPath = this.util.getFullRoutePathByActivatedRoute('', lastActivatedRoute);
      }
    });
  }

  private addLink( collection:any[], item:any, options?:string[], roles?:string[], exclude?:string ) {
    let shouldAdd = false;
    let couldAdd = false;
    if( options ) {
      for (const option of options) {
        if (this.userContext.accountHasOption(option)) {
          shouldAdd = true;
          break;
        }
      }
    }
    if( roles ) {
      for (const role of roles) {
        if (this.userContext.hasRole(role)) {
          shouldAdd = true;
          break;
        }
      }
    }
    //console.log("About to add " + item.label + " " + shouldAdd + " " + couldAdd);
    if( (shouldAdd || couldAdd) && !collection.filter(c => c.label === item.label ).length && ( !exclude || !collection.filter(c => c.label === exclude ).length)) {
      collection.push(item);
      //console.log("\tAdded " + item.label);
    } else if( !shouldAdd && !couldAdd ) {
      for (const [i, n] of collection.entries()) {
        if( n.label === item.label) {
          collection.splice(i, 1);
        }
      }
    }
  }

  public ngOnInit(): void {
  }

  public linkFor(link:any): string[] {
    return [link.link];
  }

  public accountLinkFor(link:any): string[] {
    let paths = link.path.split("/").map(p => p === ":id" ? this.userContext.account.id : p);
    paths.pop();
    return paths;
  }

  public resetAccount() {
    this.userContext.resetAccount();
    this.locationSummaryService.clear();
    this.router.navigate(['', 'accounts']);
  }

  public colorFor(link:any): string {
    //console.log("comparing " + link.link + " to " + this.previousPath);
    return (this.previousPath || "").startsWith(link.link) ? "#4a5ec9" : "#444";
  }

  public classesFor(link:any): string {
    //console.log("comparing " + link.link + "/" + link.path + " to " + this.previousPath);
    let classes = [];
    if( (link.link && (this.previousPath || "").endsWith(link.link + "/")) || (link.path && this.previousPath === link.path )) {
      classes.push('selected');
    }
    if( link.space ) {
      classes.push('section');
    }
    return classes.join(" ");
  }


  get currentUser(): any {
    return this.userContext.user;
  }

  public isAdministrator() {
    return this.userContext.hasRole('administrator');
  }

  public isAdministratorOrManager() {
    return this.userContext.hasRole('administrator') || this.userContext.hasRole('manager');
  }

  public logout() {
    this.authService.logout();

    this.router.navigate(['auth', 'login']);
  }

  get locations(): any[] {
    return this.locationSummaryService.locationSummary;
  }

  get storeLinks():Array<any> {
    return this.locations.map(l => {
      return {
        label: l.name,
        click: (dataItem) => {
          console.log("Clicked on store " + JSON.stringify(l));
          this.openStore(l);
        }
      }
    });
  }

  openStore(location: any) {
    console.log("Using context: " + JSON.stringify(this.userContext.account,null,4));
    if ( this.userContext.account.billing.currency === 'USD' ) {
      const url = `https://store.fitsamerica.com/#/location/${location.id}/shop`;
      window.open(url);
    } else {
      const url = `https://store.fitscanada.com/#/location/${location.id}/shop`;
      window.open(url);
    }
  }
}
